module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('h1', {
    staticClass: "pageTitle",
    class: {
      'pageTitle--dark': !_vm.isInOwnRoute
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.productBundles.edit.title')))])])], 1), _vm._v(" "), _c('div', {
    class: {
      'whiteWrapper': _vm.isInOwnRoute
    }
  }, [(_vm.isInOwnRoute) ? _c('el-tabs', {
    attrs: {
      "value": "1"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.productBundles.formTabs.bundleInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.productBundles",
      "hasLabel": true
    }
  }), _vm._v(" "), _c('div', [_c('div', [_c('el-button', {
    staticClass: "primary small",
    on: {
      "click": _vm.showBulkAddModal
    }
  }, [_vm._v("Add Product")])], 1), _vm._v(" "), _vm._l((_vm.list), function(group, i) {
    return _c('div', [_c('div', {
      staticStyle: {
        "margin-top": "30px"
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      staticStyle: {
        "display": "flex",
        "column-gap": "0.625rem"
      },
      attrs: {
        "xs": 24
      }
    }, [_c('div', {
      staticStyle: {
        "width": "300px"
      }
    }, [_c('el-input', {
      model: {
        value: (group.name),
        callback: function($$v) {
          _vm.$set(group, "name", $$v)
        },
        expression: "group.name"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v(_vm._s(_vm.$t('form.productBundles.groupName.label')))])], 2), _vm._v(" "), (_vm.groupErrors[("bundles." + i + ".name")]) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.groupErrors[("bundles." + i + ".name")][0]))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "200px"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (group.price),
        callback: function($$v) {
          _vm.$set(group, "price", $$v)
        },
        expression: "group.price"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v(_vm._s(_vm.$t('form.productBundles.groupPrice.label')))])], 2), _vm._v(" "), (_vm.groupErrors[("bundles." + i + ".price")]) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm.groupErrors[("bundles." + i + ".price")][0]))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "130px"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (group.taxPerc),
        callback: function($$v) {
          _vm.$set(group, "taxPerc", $$v)
        },
        expression: "group.taxPerc"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v(_vm._s(_vm.$t('form.productBundles.groupTax.label')))])], 2)], 1)])], 1)], 1), _vm._v(" "), _c('v-form-table', {
      attrs: {
        "form": _vm.formTable,
        "list": group.items,
        "update": _vm.updateTable,
        "destroy": _vm.destroyTable,
        "stack": {
          price: 'productDepositName'
        },
        "noResultWarningText": "No Result",
        "translation": "table.productBundles"
      }
    })], 1)
  })], 2)], 1)], 1)], 1) : _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.productBundles",
      "hasLabel": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [(_vm.isInOwnRoute) ? _c('el-button', {
    staticClass: "danger",
    on: {
      "click": _vm.destroy
    }
  }, [_vm._v(_vm._s(_vm.$t('button.delete').toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    class: {
      'outline': _vm.isInOwnRoute
    },
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58da4647","hasScoped":false}!./src/app/pages/withNavigation/productBundles/edit/edit.html
// module id = 3019
// module chunks = 1